import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '@/api/client';
import { Eye } from 'lucide-react';

function RSVPModal({ eventId, eventTitle, open, onClose }) {
  const { data: rsvps = [] } = useQuery({
    queryKey: ['ev-rsvps', eventId],
    queryFn: async () => (await api.get(`/admin/events/${eventId}/rsvps`)).data,
    enabled: open,
  });
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50" onClick={onClose}>
      <div className="bg-white rounded-2xl max-w-3xl w-full max-h-[80vh] overflow-auto" onClick={(e) => e.stopPropagation()}>
        <div className="sticky top-0 bg-moj-purple text-white p-4 flex justify-between items-center">
          <h3 className="font-serif">RSVPs — {eventTitle}</h3>
          <button onClick={onClose} className="text-white" aria-label="Close">✕</button>
        </div>
        <table className="w-full text-sm">
          <thead className="bg-moj-cream"><tr><th className="text-left p-3">Name</th><th className="text-left p-3">Contact</th><th className="p-3">Adults</th><th className="p-3">Children</th><th className="text-left p-3">Note</th></tr></thead>
          <tbody>
            {rsvps.map((r) => (
              <tr key={r.id} className="border-t">
                <td className="p-3 font-semibold">{r.full_name}</td>
                <td className="p-3 text-xs">{r.email}<br/>{r.phone}</td>
                <td className="p-3 text-center">{r.adults_count}</td>
                <td className="p-3 text-center">{r.children_count}</td>
                <td className="p-3 text-xs italic max-w-xs">{r.prayer_note}</td>
              </tr>
            ))}
            {rsvps.length === 0 && (
              <tr><td colSpan={5} className="text-center p-4 text-moj-charcoal/60">No RSVPs yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default function RSVPViewer({ eventId, eventTitle }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button onClick={() => setOpen(true)} className="text-moj-purple hover:bg-moj-cream p-2 rounded" aria-label="View RSVPs" data-testid={`view-rsvps-${eventId}`}>
        <Eye size={16}/>
      </button>
      <RSVPModal eventId={eventId} eventTitle={eventTitle} open={open} onClose={() => setOpen(false)}/>
    </>
  );
}
